import React, { createContext, useContext, useState, ReactNode } from 'react';

// Define the type for the context value
interface LoadingContextType {
    loading: boolean;
    setLoading: React.Dispatch<React.SetStateAction<boolean>>;
    preloadedData: any;
    setPreloadedData: React.Dispatch<React.SetStateAction<any>>;
}

// Create the context with a default value of undefined
const LoadingContext = createContext<LoadingContextType | undefined>(undefined);


export const useLoading = () => {
    const context = useContext(LoadingContext);
    if (!context) {
        throw new Error('useLoading must be used within a LoadingProvider');
    }
    return context;
};

interface LoadingProviderProps {
    children: ReactNode;
}

export const LoadingProvider = ({ children }: LoadingProviderProps) => {
    const [loading, setLoading] = useState<boolean>(false);
    const [preloadedData, setPreloadedData] = useState<any>(null);

    return (
        <LoadingContext.Provider value={{ loading, setLoading, preloadedData, setPreloadedData }}>
            {children}
        </LoadingContext.Provider>
    );
};
